import kyChat from './src/index.vue'

/* istanbul ignore next */
kyChat.install = function (Vue) {
  Vue.component(kyChat.name, kyChat)
}

export default kyChat



//////////////////
// WEBPACK FOOTER
// ./packages/chat/index.js
// module id = null
// module chunks = 